<template>
  <div class="common-body"> 
    <Header :loginState="loginState" @changeSuspendState="changeSuspendState"
    @changeLoginState="changeLoginState" @changeSuspendType="changeSuspendType"></Header>
    <a class="notice-banner" :href="banner.banner_address" target="_blank">
      <img class="notice-img" :src="baseAddress+banner.banner_url">
    </a>
    <div class="notice-body">
      <h1 class="notice-title">{{news.news_title}}</h1>
      <div class="notice-sub">
        <span class="notice-sub-span" style="margin-right: 60px;">发布人 : {{news.news_source == null ?'101游戏小编':news.news_source}}</span>
        <span class="notice-sub-span">发布时间 : {{new Date(news.news_time).Format("yyyy/MM/dd")}}</span>
      </div>
      <div class="notice-content" v-html="unescapeHTML(news.news_content)"></div>
      <div class="notice-bottom"> 
        <span class="notice-bottom-span" style="margin-right: 20px;" v-show="nextNews.news_state == 0">上一篇 : 没有了</span>
        <span class="notice-bottom-span" style="margin-right: 20px;" v-show="nextNews.news_state == 1" @click="enterInformationDetails(nextNews.news_id,nextNews.news_type)">上一篇 : {{nextNews.news_title}}</span>
        <span class="notice-bottom-span" v-show="prevNews.news_state == 0">下一篇 : 没有了</span>
        <span class="notice-bottom-span" v-show="prevNews.news_state == 1" @click="enterInformationDetails(prevNews.news_id,prevNews.news_type)">下一篇 : {{prevNews.news_title}}</span>
      </div>
      <span class="notice-bottom-label">相关文章</span>
      <ul class="notice-ul">
        <li class="notice-li" :class="index%2 == 0 ? 'mr-20':''"
         v-for="(item,index) in newsList" @click="enterInformationDetails(item.news_id,item.news_type)">
          <span class="notice-li-title">◇ {{item.news_title}}</span>
          <span class="notice-li-time">[{{new Date(item.news_time).Format("MM/dd")}}]</span>
        </li>
      </ul>
    </div>
    <Footer></Footer>
    <SuspendSide></SuspendSide>
    <SuspendMember :suspendType="suspendType" :suspendState="suspendState"
      @changeSuspendState="changeSuspendState" @changeSuspendType="changeSuspendType"
      @changeLoginState="changeLoginState"></SuspendMember>
  </div>
</template>
<script>
  import Footer from "../../components/common/Footer";
  import Header from "../../components/common/Header";
  import SuspendSide from "../../components/SuspendSide";
  import SuspendMember from '../../components/SuspendMember';
  export default {
    metaInfo(){
      return {
        title:"平台公告_"+this.$store.state.home.title,
        meta:[
          { name:'keywords', content:this.$store.state.home.keywords},
          { name:'description',content:this.$store.state.home.description}
        ]
      }
    },
    components:{ Footer, Header, SuspendSide, SuspendMember},
    computed:{
      baseImageAddress(){
        return this.$store.state.constant.baseImageAddress;
      },
      baseAddress(){
        return this.$store.state.constant.baseAddress;
      },
      banner(){
        return this.$store.state.informationNotice.banner;
      },
      news(){
        return this.$store.state.informationNotice.news;
      },
      nextNews(){
        return this.$store.state.informationNotice.nextNews;
      },
      prevNews(){
        return this.$store.state.informationNotice.prevNews;
      },
      newsList(){
        return this.$store.state.informationNotice.newsList;
      }
    },
    asyncData({store,route}){
      return store.dispatch('initInformationNotice',route.query.news_id);
    },
    data(){
      return{
        suspendState:false,
        suspendType:0
      }
    },
    methods:{ 
      changeSuspendType(value){
        this.suspendType = value;
      },
      changeSuspendState(value){
        this.suspendState = value;
      },
      changeLoginState(value){
        this.loginState = value;
      },
      enterInformationDetails(value,type){
        if(type == 8){
          this.$router.push({name:"informationNotice",query:{news_id:value}});
        }else{
          this.$router.push({name:'informationDetails',query:{news_id:value}});
        }
      },
      unescapeHTML: function(content){
        content = "" + content;
        content = content.replace(/&lt;/g, "<").replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&").replace(/&quot;/g, '"')
        .replace(/&apos;/g, "'")
        .replace(new RegExp('background-color: #ffffff;','g'), "")
        .replace(new RegExp('background:rgb(255,255,255)','g'), "")
        .replace(new RegExp('background: rgb(255, 255, 255)','g'), "")
        .replace(new RegExp('background: #ffffff;','g'),"");
        content = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
          let replace;
          if(capture.substr(0,7) == 'http://'){
            replace = capture;
          }else if(capture.substr(0,1) =="/"){
            replace ="http://sdk.101yx.com"+capture;
          }else{
            replace = "http://sdk.101yx.com/"+capture;
          }
            return match.replace(capture,replace);
          });
        return content;
      },
    },
  }
</script>
<style src="@/assets/css/information/information_notice.css" scoped></style>
<style>
  .notice-content{
    font-size: 16px;
  }

  .notice-content img{
    width: 100%;
    height: 100%;
  }

  .notice-content table{
    width: 100%;
  }

  .notice-content p,.notice-content span{
    color: rgba(21, 21, 21, 0.73);
  }
  </style>